module.exports = __webpack_public_path__ + "media/images/logos/University-of-Manchester-f63ef17e6d5d001356f9dee21f3baeba.svg";